import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { dlGtpDataVolumeNrChartConfig } from '../chartConfigs';

/**
 * Props for the DlGtpDataVolumeNrEcharts component
 */
interface DlGtpDataVolumeNrEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Downlink GTP Data Volume Chart (NR Site Level)
 * 
 * Displays downlink S1-U GTP Tunneling Protocol data volume in GB for NR sites.
 * Tracks total downlink throughput across all cells for capacity planning and monitoring.
 * 
 * @component
 * @example
 * ```tsx
 * <DlGtpDataVolumeNrEcharts onFullscreenToggle={handleFullscreen} isFullscreen={false} />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (dlGtpDataVolumeNrChartConfig)
 * @see {@link ../../../components/SiteCharts/SiteCharts.tsx} - Template component
 * @see API: /api/nr/dl-gtp-data-volume?site_name={siteName}
 */
const DlGtpDataVolumeNrEcharts: React.FC<DlGtpDataVolumeNrEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={dlGtpDataVolumeNrChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default DlGtpDataVolumeNrEcharts;
